export const formatPhone = (number: string) => {
  const phoneNumber = number.slice(2)
  const digits = phoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (digits) return `(${digits[1]}) ${digits[2]}-${digits[3]}`
  return null
}
